import { useEffect, useState } from 'react'
import { GetActiveReportingYear } from '../services/peerToPeer/PeerToPeerService'
import { GetP2PCompletions } from '../services/peerToPeer/DashboardService'
import { type CompletionsView } from '../models/peerToPeer/Collection'
import { handleApiResponse } from '../utils/apiHelpers'

interface UseP2PCompletionsType {
  model: CompletionsView | null
  reportingYearId: number
  isLoading: boolean
}

export const useP2PCompletions = (): UseP2PCompletionsType => {
  const [model, setModel] = useState<CompletionsView | null>(null)
  const [reportingYearId, setReportingYearId] = useState<number>(0)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    const load = async (): Promise<void> => {
      const year = await handleApiResponse(GetActiveReportingYear())
      if (year != null) {
        setReportingYearId(year.id)
        setModel(await handleApiResponse(GetP2PCompletions(year.id)))
      }
      setIsLoading(false)
    }

    void load()
  }, [])

  return { model, reportingYearId, isLoading }
}
